var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing;
  return {
    timeInputWrapperPadding: spacing.xxSmall,
    timeInfoPadding: spacing.xSmall,
    errorPadding: spacing.xSmall
  };
};
export default generateComponentTheme;